module.exports = __webpack_public_path__ + "static/media/04.ef8fcc37.mp3";